// PubSub library for cart/product updates
window.PubSub = {
  subscribe: function(event, callback) {},
  publish: function(event, data) {}
};
